import React from 'react';

import AllFeedback from './FeedbackImport/AllFeedback';
import FeedBackStats from './FeedbackImport/FeedbackStats';
import ComplaintsChart from './FeedbackImport/ComplaintsChart';
import EscalationMode from './FeedbackImport/EscalationMode';
import { Link } from 'react-router-dom';
import BreadCrumb from '../BreadCrumb';

const pages = [
  { name: 'Customer Care', to: '/customers', component: Link, current: false },
  { name: 'Customer Feedback Admin', to: '/customers/feedback', component: Link, current: true },  
  
];

const FeedbackManager = () => {


    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
             <BreadCrumb pages={pages} />

             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Page Header */}
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-2">
                        Feedback Management
                    </h1>
                    <p className="text-gray-600">
                        Monitor and manage customer feedback, complaints, and commendations
                    </p>
                </div>

                {/* Main Content Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
                    {/* Feedback List - Takes 3 columns */}
                    <div className="lg:col-span-3">
                        <AllFeedback />
                    </div>

                    {/* Stats Sidebar - Takes 1 column */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-4">
                            <FeedBackStats />
                        </div>
                    </div>
                </div>

                {/* Analytics Charts */}
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                    {/* Escalation Mode Chart */}
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-2xl shadow-lg p-6 h-full">
                            <div className="flex items-center mb-6">
                                <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-xl flex items-center justify-center mr-3">
                                    <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                    </svg>
                                </div>
                                <h2 className="text-xl font-bold text-gray-900">
                                    Top Escalation Channels
                                </h2>
                            </div>
                            <div className="mt-4">
                                <EscalationMode />
                            </div>
                        </div>
                    </div>

                    {/* Complaints Chart */}
                    <div className="lg:col-span-3">
                        <div className="bg-white rounded-2xl shadow-lg p-6 h-full">
                            <div className="flex items-center mb-6">
                                <div className="w-10 h-10 bg-gradient-to-br from-rose-500 to-pink-600 rounded-xl flex items-center justify-center mr-3">
                                    <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                </div>
                                <h2 className="text-xl font-bold text-gray-900">
                                    Top Complaints
                                </h2>
                            </div>
                            <div className="mt-4">
                                <ComplaintsChart />
                            </div>
                        </div>
                    </div>
                </div>
             </div>
        </div>

    );
};

export default FeedbackManager;
